import { axios, reqInterceptor, reqErr, repInterceptor, repErr } from './axios'
import { baseUrl, baseUrlMap, API_LIST } from 'api/config'

const apis = {}
const api = `${baseUrl}/planBook/V2`
const initApis = (apiName, type, interceptors, base) => {
  let instance = axios.create()
  let [key, name] = apiName
  let iapi = api

  // 自定义路径
  if (name.indexOf('/') > -1) {
    // 支持新api域名
    let baseOrigin = baseUrl
    if (base && baseUrlMap[base]) {
      baseOrigin = baseUrlMap[base]
    }
    iapi = baseOrigin + name.substring(0, name.lastIndexOf('/'))
    name = name.substring(name.lastIndexOf('/') + 1, name.length)
  }

  apis[key] = (params, path, config) => {
    if (interceptors) {
      instance.interceptors.request.use(reqInterceptor, reqErr)
      instance.interceptors.response.use(repInterceptor, repErr)
    }
    let ipath = path ? `/${path}` : ''
    if (type === 'post') {
      return instance
        .post(`${iapi}/${name}${ipath}`, params, config)
        .then(res => res.data)
    } else {
      return instance.get(`${iapi}/${name}${ipath}`, {
        params,
        config
      })
    }
  }
}

API_LIST.forEach(a => {
  initApis([a[0], a[1]], a[2], a[3], a[4])
})

const {
  getUser,
  getClientInfo,
  getResult,
  visitTs,
  initInterest,
  getInterest,
  preview,
  clause,
  resultMultiple,
  queryAdvert,
  getMembers,
  getFamilyResult,
  getMultiResult,
  exportPlanData,
  getCompanyList,
  getBeneficiary,
  getCompany,
  getPbCompareResult,
  saveWxClient,
  isWechatGroup,
  saveOperate,
  saveHumanPath,
  addPbCount,
  liabilities,
  compareMission,
  abTestForMultiGroup,
  diseaseCompare,
  diseaseV2,
  diseaseListV2,
  diseaseDetail,
  multiCompare,
  getResultCategory,
  getInsuranceCategory,
  compareByCategory,
  getChunYun,
  createByExample,
  getAllCondition,
  setShareName,
  getCard,
  getNewCard,
  clauseSwitch,
  getRenewRateList,
  completeMission,
  nameExplain,
  signPopup,
  haveRecommend,
  addFamilyPlanbook,
  getAccountRateList,
  getVideoList,
  updatePBProductVideoTypeInfo,
  wxClientSaveOperate,
  isTestUser,
  createGroup,
  pollingListAvailableGroups,
  validateAAT,
  modifyAAT,
  getInterestDetail,
  resultShare,
  getApplicationInfo,
  pbCompare,
  getRecords,
  saveVersionNum,
  policyInfo,
  sendAudio,
  getIrrInfo,
  getPublicResult,
  getPublicClause,
  initPublicInterest,
  getPublicInterest,
  pbCompareShare,
  getExportOption,
  getTermParseMindmap
} = apis

export {
  getUser,
  getClientInfo,
  getResult,
  visitTs,
  initInterest,
  getInterest,
  preview,
  clause,
  resultMultiple,
  queryAdvert,
  getMembers,
  getFamilyResult,
  getMultiResult,
  exportPlanData,
  getCompanyList,
  getBeneficiary,
  getCompany,
  getPbCompareResult,
  saveWxClient,
  isWechatGroup,
  saveOperate,
  saveHumanPath,
  addPbCount,
  liabilities,
  compareMission,
  abTestForMultiGroup,
  diseaseCompare,
  diseaseV2,
  diseaseListV2,
  diseaseDetail,
  multiCompare,
  getResultCategory,
  getInsuranceCategory,
  compareByCategory,
  getChunYun,
  createByExample,
  getAllCondition,
  setShareName,
  getCard,
  getNewCard,
  clauseSwitch,
  getRenewRateList,
  completeMission,
  nameExplain,
  signPopup,
  haveRecommend,
  addFamilyPlanbook,
  getAccountRateList,
  getVideoList,
  updatePBProductVideoTypeInfo,
  wxClientSaveOperate,
  isTestUser,
  createGroup,
  pollingListAvailableGroups,
  validateAAT,
  modifyAAT,
  getInterestDetail,
  resultShare,
  getApplicationInfo,
  pbCompare,
  getRecords,
  saveVersionNum,
  policyInfo,
  sendAudio,
  getIrrInfo,
  getPublicResult,
  getPublicClause,
  initPublicInterest,
  getPublicInterest,
  pbCompareShare,
  getExportOption,
  getTermParseMindmap
}
